import BaseHttp from 'src/commons/store/BaseHttp'
import { API_URL, HttpSuccessType1, HttpSuccessType2, HttpSuccessType3 } from 'src/commons/utils/Commons'
import DealWithHttp from 'src/commons/store/DealWithHttp'
import MobXHttp from 'src/commons/store/MobXHttp'

/** 申请云游戏订单 */
const applyCloudGameOrder = BaseHttp<
  { startGameNo: string; gameId: number; queue?: boolean },
  ApiResult2<TCloudGameOrder>
>({
  Url: `${API_URL.BOX_WEB}/api/user/game/cloud/no/gen`,
  Type: 'Get',
})
export const DWApplyCloudGameOrder = DealWithHttp(applyCloudGameOrder, HttpSuccessType2)
export const ApplyCloudGameOrderHS = MobXHttp(DWApplyCloudGameOrder)

/** 云游戏-建立会话连接 */
const applyCloudGameConnect = BaseHttp<TCloudGameConnectQuery, ApiResult2<TCloudGameConnectResult>>({
  Url: `${API_URL.BOX_WEB}/api/user/game/cloud/connect`,
  Type: 'Post',
})
export const DWApplyCloudGameConnect = DealWithHttp(applyCloudGameConnect, HttpSuccessType2)
export const ApplyCloudGameConnectHS = MobXHttp(DWApplyCloudGameConnect)

/** 云游戏-事件消息上报 */
const applyCloudGameReport = BaseHttp<TCloudGameReportQuery, ApiResult2<null>>({
  Url: `${API_URL.BOX_WEB}/api/user/game/cloud/event/msg/advice`,
  Type: 'Post',
})
export const DWApplyCloudGameReport = DealWithHttp(applyCloudGameReport, HttpSuccessType2)
export const ApplyCloudGameReportHS = MobXHttp(DWApplyCloudGameReport)

/** 云游戏-主动停止云游戏计费 */
const doCloudGameStop = BaseHttp<
  Pick<TCloudGameConnectQuery, 'gameCloudOrderNo'> & { reason?: string },
  ApiResult2<null>
>({
  Url: `${API_URL.BOX_WEB}/api/user/game/cloud/stop`,
  Type: 'Get',
})
export const DWDoCloudGameStop = DealWithHttp(doCloudGameStop, HttpSuccessType2)
export const DoCloudGameStopHS = MobXHttp(DWDoCloudGameStop)

/** 云游戏-保存存档 */
const saveCloudGameArchive = BaseHttp<{ id: string; name: string }, ApiResult2<null>>({
  Url: `${API_URL.BOX_WEB}/anon/cloud/saveLog/updateCloudGameCloudSaveLogInfo`,
  Type: 'Post',
})
export const DWSaveCloudGameArchive = DealWithHttp(saveCloudGameArchive, HttpSuccessType2)
export const SaveCloudGameArchiveHS = MobXHttp(DWSaveCloudGameArchive)

/** 查询用户排队资源信息 */
const queryResourceQueue = BaseHttp<{ gameId: number; queueMainId?: string }, ApiResult2<TResourceQueueInfo>>({
  Url: `${API_URL.BOX_WEB}/api/user/game/resource/queue/query`,
  Type: 'Get',
})
export const DWQueryResourceQueue = DealWithHttp(queryResourceQueue, HttpSuccessType2)
export const QueryResourceQueueHS = MobXHttp(DWQueryResourceQueue)

/** 加入资源排队 */
const enterResourceQueue = BaseHttp<TJoinResourceQueue, ApiResult2<TJoinResourceQueueResponse>>({
  Url: `${API_URL.BOX_WEB}/api/user/game/resource/queue/enter`,
  Type: 'Post',
})
export const DWEnterResourceQueue = DealWithHttp(enterResourceQueue, HttpSuccessType2)
export const EnterResourceQueueHS = MobXHttp(DWEnterResourceQueue)

/** 取消资源排队 */
const cancelResourceQueue = BaseHttp<TCancelResourceQueue, ApiResult2<null>>({
  Url: `${API_URL.BOX_WEB}/api/user/game/resource/queue/cancel`,
  Type: 'Get',
})
export const DWCancelResourceQueue = DealWithHttp(cancelResourceQueue, HttpSuccessType2)
export const CancelResourceQueueHS = MobXHttp(DWCancelResourceQueue)

/** 排队成功后启动游戏 */
const confirmStartGame = BaseHttp<StartGameQuery & QueueSuccessStartGame, ApiResult2<TStartGameHttp>>({
  Url: `${API_URL.BOX_WEB}/api/startGame/confirm`,
  Type: 'Post',
})
export const DWConfirmStartGame = DealWithHttp(confirmStartGame, HttpSuccessType2)
export const ConfirmStartGameHS = MobXHttp(DWConfirmStartGame)

/** 新增停止游戏接口 (退出在线的游戏, 不分模式) */
const forceStopGame = BaseHttp<{ startGameNo: string; reason: string }, ApiResult2<null>>({
  Url: `${API_URL.BOX_WEB}/api/current/game/stop`,
  Type: 'Post',
})
export const DWForceStopGame = DealWithHttp(forceStopGame, HttpSuccessType2)

/** 邀请游客加入互动房间 */
const invitePlayer = BaseHttp<THttpInvitePlayerQuery, ApiResult2<THttpInvitePlayerResponse>>({
  Url: `${API_URL.BOX_WEB}/api/gameCloud/room/invitation`,
  Type: 'Post',
})
export const DWInvitePlayer = DealWithHttp(invitePlayer, HttpSuccessType2)

/** 取消邀请游客加入互动房间 */
const cancelInvitePlayer = BaseHttp<THttpCancelInvitePlayerQuery, ApiResult2<null>>({
  Url: `${API_URL.BOX_WEB}/api/gameCloud/room/invitation/cancel`,
  Type: 'Post',
})
export const DWCancelInvitePlayer = DealWithHttp(cancelInvitePlayer, HttpSuccessType2)

/** 游客拒绝加入互动房间 */
const rejectJoinRoom = BaseHttp<THttpRejectJoinRoomQuery, ApiResult2<null>>({
  Url: `${API_URL.BOX_WEB}/api/gameCloud/room/refused`,
  Type: 'Post',
})
export const DWRejectJoinRoom = DealWithHttp(rejectJoinRoom, HttpSuccessType2)

/** 游客连接加入互动房间 */
const connectRoom = BaseHttp<THttpConnectRoomQuery, ApiResult2<THttpConnectRoomResponse>>({
  Url: `${API_URL.BOX_WEB}/api/gameCloud/room/connect`,
  Type: 'Post',
})
export const DWConnectRoom = DealWithHttp(connectRoom, HttpSuccessType2)

/** 游客退出互动房间 */
const exitRoom = BaseHttp<THttpExitRoomQuery, ApiResult2<null>>({
  Url: `${API_URL.BOX_WEB}/api/gameCloud/room/quit`,
  Type: 'Post',
})
export const DWExitRoom = DealWithHttp(exitRoom, HttpSuccessType2)

/** 主播主动拿回控制权 */
const recoverControl = BaseHttp<THttpRecoverControlQuery, ApiResult2<null>>({
  Url: `${API_URL.BOX_WEB}/api/gameCloud/room/control/regain`,
  Type: 'Post',
})
export const DWRecoverControl = DealWithHttp(recoverControl, HttpSuccessType2)

/** 云游戏反馈 - 是否需要弹出反馈弹窗 */
const cloudGameShouldFeedBack = BaseHttp<null, ApiResult2<boolean>>({
  Url: `${API_URL.BOX_WEB}/api/last/month/feedback/can/is`,
  Type: 'Get',
})
export const DWCloudGameShouldFeedBack = DealWithHttp(cloudGameShouldFeedBack, HttpSuccessType2)

/** 云游戏反馈 - 反馈赠送的云游戏时长 */
const cloudGameFeedBackConfig = BaseHttp<null, ApiResult2<number>>({
  Url: `${API_URL.BOX_WEB}/anon/platform/give/cloud/time/config/get`,
  Type: 'Get',
})
export const DWCloudGameFeedBackConfig = DealWithHttp(cloudGameFeedBackConfig, HttpSuccessType2)
